export interface State {
  flags: Record<string, boolean>;
  loaded: boolean;
  error: string | null;
}

export const initialState: State = {
  flags: {},
  loaded: false,
  error: null,
};
